import React, { useEffect, useState } from 'react';
import { fetchHelpContent } from '../help-content-service';
import './help-modal.css';

const HelpModal = ({ isOpen, onClose, helpPath }) => {
    const [helpContent, setHelpContent] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
      if (isOpen && helpPath) {
        setIsLoading(true);
        setError(null);

        fetchHelpContent(helpPath)
          .then(htmlContent => {
            setHelpContent(htmlContent);
          })
          .catch(err => {
            setError(`Impossible de charger le contenu d'aide: ${err.message}`);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }, [isOpen, helpPath]); 

    useEffect(() => {
     const handleEscKey = (event) => {
       if (isOpen && event.key === 'Escape') {
         onClose();
       }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose, isOpen]);

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <div 
      className="modal-help-overlay" 
      onClick={onClose}
    >
      <div className="modal-help-content" onClick={handleContentClick}>
        <button className="close-welcome-button" onClick={onClose}>
          X
        </button>
        <div className="modal-help-body">
          {isLoading ? (
            <div className="help-loading">Chargement...</div>
          ) : error ? (
            <div className="help-error">{error}</div>
          ) : helpContent ? (
            <div dangerouslySetInnerHTML={{ __html: helpContent }} />
          ) : (
            <div className="help-error">Aucun contenu disponible</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
